import { render, staticRenderFns } from "./NavigationCard.vue?vue&type=template&id=3c88e987&scoped=true"
import script from "./NavigationCard.vue?vue&type=script&lang=js"
export * from "./NavigationCard.vue?vue&type=script&lang=js"
import style0 from "./NavigationCard.vue?vue&type=style&index=0&id=3c88e987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c88e987",
  null
  
)

export default component.exports